import { DEBUG_MODE } from './config'
import {
  isNotNullOrEmptyString,
  isNotNullOrUndefined,
  isNullOrEmptyString,
  toTrimmedStringLowerCase,
} from './misc'

export const LANGUAGE_CODE_SPANISH: string = 'es'
export const LANGUAGE_CODE_ENGLISH: string = 'en'
export const LANGUAGE_CODE_FRENCH: string = 'fr'
export const LANGUAGE_CODE_KOREAN: string = 'ko'
export const UNITED_STATES_ISO_3166_ALPHA_2_CODE: string = 'US'
export const CANADA_ISO_3166_ALPHA_2_CODE: string = 'CA'
export const BRITAIN_ISO_3166_ALPHA_2_CODE: string = 'GB'
export const BRITAIN_ISO_3166_ALPHA_2_CODE_ALT: string = 'UK'
export const SOUTH_KOREA_ISO_3166_ALPHA_2_CODE: string = 'KR'
export const FRANCE_ISO_3166_ALPHA_2_CODE: string = 'FR'
export const SPAIN_ISO_3166_ALPHA_2_CODE: string = 'ES'
export const LANGUAGE_LOCALE_CODE_US_ENGLISH: string =
  LANGUAGE_CODE_ENGLISH + '-US'

export function isSpanish(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_SPANISH
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isFrench(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_FRENCH
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isKorean(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_KOREAN
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isEnglish(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_ENGLISH
      ) == 0 || isNullOrEmptyString(selectedLanguage)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function translate(
  englishText: any,
  spanishText: any,
  frenchText: any,
  koreanText: any,
  overrideLanguage: any
) {
  let ret: string = englishText
  try {
    ret =
      isNotNullOrUndefined(overrideLanguage) &&
      toTrimmedStringLowerCase(overrideLanguage).indexOf(
        LANGUAGE_CODE_ENGLISH
      ) == 0
        ? englishText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_SPANISH
          ) == 0
        ? spanishText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_FRENCH
          ) == 0
        ? frenchText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_KOREAN
          ) == 0
        ? koreanText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_SPANISH
          ) == 0
        ? spanishText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_FRENCH
          ) == 0
        ? frenchText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_KOREAN
          ) == 0
        ? koreanText
        : englishText
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return isNotNullOrEmptyString(ret) ? ret : englishText
}

export function getNavigatorLanguage() {
  let ret: string = LANGUAGE_LOCALE_CODE_US_ENGLISH
  try {
    ret = isNotNullOrEmptyString(navigator?.language)
      ? navigator?.language
      : LANGUAGE_LOCALE_CODE_US_ENGLISH
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isValidLanguage(s: any) {
  let ret: boolean = false
  try {
    ret =
      isNotNullOrEmptyString(s) &&
      (s.indexOf(LANGUAGE_CODE_SPANISH) == 0 ||
        s.indexOf(LANGUAGE_CODE_ENGLISH) == 0 ||
        s.indexOf(LANGUAGE_CODE_FRENCH) == 0 ||
        s.indexOf(LANGUAGE_CODE_KOREAN) == 0)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
